import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignSelf: 'flex-start',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',

    background: theme.palette.custom.background.area,
    boxShadow: theme.shadows[25],
    margin: `${theme.spacing(3)}px auto`,
    maxWidth: theme.spacing(80),
    overflow: 'hidden',
    maxHeight: `calc(100% - ${theme.spacing(6)})`,
    padding: theme.spacing(0, 3, 3),

    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(3, 0),
    },

    '& .send-error': {
      '&-title': {
        color: theme.palette.text.secondary,
        padding: theme.spacing(6, 0),
      },
      '&-icon': {
        fontSize: theme.spacing(8),
        color: theme.palette.custom.feedback.warning,
      },
      '&-message': {
        color: theme.palette.text.secondary,
        margin: theme.spacing(2, 0),
        maxWidth: theme.spacing(40),
      },
      '&-button': {
        margin: theme.spacing(6, 0, 3),
      },
    },
  },
}));

export default styles;
